import {slide as Menu} from 'react-burger-menu';
import {decorator as reduxBurgerMenu} from 'redux-burger-menu';

export default reduxBurgerMenu(Menu);



// WEBPACK FOOTER //
// ./src/snapit_app/components/Menu.js